'use strict';

/* ----------------------------------------
 * -- Sliders --
 * 
 * Configuration Options:
 *                loop:  BOOLEAN  Both; If no option given, programmatically set to true.
 *                dots:  BOOLEAN  Both; If no option given, programmatically set to true.
 *          pagination:  OBJECT   Swiper only; If no option given, pagination is omitted from slider settings.
 *              arrows:  BOOLEAN  Both; If no option given, automatically set to true in widget background.
 *      arrowsPosition:  STRING   ['inside' or 'outside'] Swiper only; If no option given, automatically set to the outside.
 *          navigation:  OBJECT   Swiper only; If no option given, navigation is omitted from slider settings.
 *        slidesToShow:  NUMBER   Both; If no option given, programmatically set to 1.
 *      slidesToScroll:  NUMBER   Both; If no option given, programmatically set to 1.
 *            autoplay:  NUMBER   Both; When given, number is programmatically set to Autoplay Speed and Autoplay is set to true. If no option given, autoplay is set to false.
 *         breakpoints:  OBJECT   Both; Properties are looped over to apply various breakpoint settings. If no option given, breakpoints is omitted from slider settings.
 *     
 * Example Code:
 *        sliders.init('.some-class-name', 
 *        {
 *             loop: true, 
 *             dots: true, 
 *             pagination: {el: '.swiper-pagination', clickable: true}, 
 *             arrows: true,
 *             arrowsPosition: 'inside',
 *             navigation: {nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
 *             slidesToShow: 6,
 *             slidesToScroll: 1,
 *             autoplay: 3000,
 *             breakpoints: {0: {slidesToShow: 1}, 768: {slidesToShow: 3}}
 *        });
 * 
 * 
 * Additional configuration options exist for both sliders, but additional code changes would be needed to include them. 
 * 
 * Reference slider documentation:
 * 
 * Swiper documentation - https://swiperjs.com/swiper-api
 * Slick documentation - https://kenwheeler.github.io/slick/
 *  
 * ----------------------------------------
 */

var SiteConstants = require('../../../bc_sheplersbootbarn_core/cartridge/js/SiteConstants');

exports.init = init;
exports.initializeCategorySliders = initializeCategorySliders;
exports.initializeRecommendationSlider = initializeRecommendationSlider;
exports.initializeAddToCartEinsteinSlot = initializeAddToCartEinsteinSlot;
exports.initializeAddToCartRecommendationsSlider = initializeAddToCartRecommendationsSlider;

function getUniqueNumber() {
	var dateObject = new Date();
	var uniqueNumber = dateObject.valueOf();
    var suffixNumber = 1 + Math.floor(Math.random() * 100);
    uniqueNumber = uniqueNumber + suffixNumber;
	return uniqueNumber;
}

function convertedSlickBreakpointSize(breakpointSize, breakpointSizeArray) {
    var sortedBreakpointSizes = breakpointSizeArray.sort(function (a, b) { return a - b; });
    var convertedBreakpointSize;
    
    if (breakpointSize == 0) {
        var mobileMaxSize = sortedBreakpointSizes[sortedBreakpointSizes.indexOf(0) + 1];
        if (mobileMaxSize) {
            convertedBreakpointSize = mobileMaxSize - 1;
        } else {
            convertedBreakpointSize = 767;
        }
    } else if (breakpointSize == 768) {
        var desktopMaxSize = sortedBreakpointSizes[sortedBreakpointSizes.indexOf(768) + 1];
        if (desktopMaxSize) {
            convertedBreakpointSize = desktopMaxSize - 1;
        } else {
            convertedBreakpointSize = 9999;
        }
    } else {
        var breakpointMaxSize = sortedBreakpointSizes[sortedBreakpointSizes.indexOf(breakpointSize) + 1];
        if (breakpointMaxSize) {
            convertedBreakpointSize = breakpointMaxSize - 1;
        } else {
            convertedBreakpointSize = 9999;
        }
    }

    return convertedBreakpointSize;
}

function initSlick(elementSelector, settings) {
    if (!elementSelector) {
        return;
    }

    var sliderSettings = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1
    };
    if (settings) {
        if ('loop' in settings) {
            sliderSettings.infinite = settings.loop;
        }
        if ('dots' in settings) {
            sliderSettings.dots = settings.dots;
        }
        if ('arrows' in settings) {
            sliderSettings.arrows = settings.arrows;
        }
        if ('slidesToShow' in settings) {
            sliderSettings.slidesToShow = settings.slidesToShow;
        }
        if ('slidesToScroll' in settings) {
            sliderSettings.slidesToScroll = settings.slidesToScroll;
        }
        if ('autoplay' in settings) {
            sliderSettings.autoplay = true;
            sliderSettings.autoplaySpeed = settings.autoplay;
        }
        if ('breakpoints' in settings) {
            sliderSettings.responsive = [];
            var breakpointSizeArray = Object.keys(settings.breakpoints).map(function (x) { 
                return parseInt(x); // Extra precaution of sanitizing data for use in mathematical equations
            });
            for (var breakpointSize in settings.breakpoints) {
                breakpointSize = parseInt(breakpointSize);
                var convertedBreakpointSize = convertedSlickBreakpointSize(breakpointSize, breakpointSizeArray);
                var breakpointSettingsObject = {
                    breakpoint: convertedBreakpointSize,
                    settings: {}
                };
                var breakpointSizeSettings = settings.breakpoints[breakpointSize];
                for (var sizeSetting in breakpointSizeSettings) {
                    if ('loop' == sizeSetting) {
                        breakpointSettingsObject.settings.infinite = breakpointSizeSettings[sizeSetting];
                    }
                    if ('dots' == sizeSetting) {
                        breakpointSettingsObject.settings.dots = breakpointSizeSettings[sizeSetting];
                    }
                    if ('arrows' == sizeSetting) {
                        breakpointSettingsObject.settings.arrows = breakpointSizeSettings[sizeSetting];
                    }
                    if ('slidesToShow' == sizeSetting) {
                        if (convertedBreakpointSize == 9999) {
                            sliderSettings.slidesToShow = breakpointSizeSettings[sizeSetting];
                        } else {
                            breakpointSettingsObject.settings.slidesToShow = breakpointSizeSettings[sizeSetting];
                        }
                    }
                    if ('slidesToScroll' == sizeSetting) {
                        if (convertedBreakpointSize == 9999) {
                            sliderSettings.slidesToScroll = breakpointSizeSettings[sizeSetting];
                        } else {
                            breakpointSettingsObject.settings.slidesToScroll = breakpointSizeSettings[sizeSetting];
                        }
                    }
                    if ('autoplay' == sizeSetting) {
                        if (convertedBreakpointSize == 9999) {
                            sliderSettings.autoplay = true;
                            sliderSettings.autoplaySpeed = breakpointSizeSettings[sizeSetting].autoplay;
                        } else {
                            breakpointSettingsObject.settings.autoplay = true;
                            breakpointSettingsObject.settings.autoplaySpeed = breakpointSizeSettings[sizeSetting];
                        }
                    }
                }
                //if (convertedBreakpointSize != 9999) {
                    sliderSettings.responsive.push(breakpointSettingsObject);
                //}
            }
        }

        $(elementSelector).slick(sliderSettings);
    } else {
        $(elementSelector).slick();
    }
}

function initSwiper(elementSelector, settings, classesForSettings) {
    if (!elementSelector) {
        return;
    }

    var sliderSettings = {
        loop: true,
        spaceBetween: 20,
        preventInteractionOnTransition: true,
        a11y: {
            enabled: true,
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide'
        },
        keyboard: {
			enabled: true,
			pageUpDown: true
		}
    };
    if (settings) {
        if ('spaceBetween' in settings) {
            sliderSettings.spaceBetween = settings.spaceBetween;
        }
        if ('loop' in settings) {
            sliderSettings.loop = settings.loop;
        }
        if ('pagination' in settings || 'dots' in settings) {
            if (settings.pagination) {
                if (settings.pagination.el && settings.pagination.el.length > 0) {
                    sliderSettings.pagination = settings.pagination;
                }
            } else {
                if (settings.dots) {
                    sliderSettings.pagination = {
                        el: '.swiper-pagination',
                        clickable: true
                    }
                }
            }
        } 
        if ('navigation' in settings || 'arrows' in settings) {
            if (settings.navigation) {
                if (settings.navigation.nextEl && settings.navigation.nextEl.length > 0) {
                    sliderSettings.navigation = settings.navigation;
                }
            } else {
                if (settings.arrows) {
                    sliderSettings.navigation = {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }
        }
        if ('slidesToShow' in settings) {
            sliderSettings.slidesPerView = settings.slidesToShow;
        }
        if ('autoplay' in settings) {
            sliderSettings.autoplay = {
                delay: settings.autoplay,
                disableOnInteraction: true
            };
        }
        if ('breakpoints' in settings) {
            sliderSettings.breakpoints = {};
            for (var breakpointSize in settings.breakpoints) {
                breakpointSize = parseInt(breakpointSize);
                sliderSettings.breakpoints[breakpointSize] = {};
                var breakpointSizeSettings = settings.breakpoints[breakpointSize];
                for (var sizeSetting in breakpointSizeSettings) {
                    if ('loop' == sizeSetting) {
                        sliderSettings.loop = breakpointSizeSettings[sizeSetting];
                    }
                    if ('dots' == sizeSetting && breakpointSizeSettings[sizeSetting] == true) {
                        sliderSettings.breakpoints[breakpointSize].pagination = {
                            enabled: breakpointSizeSettings[sizeSetting],
                            el: '.swiper-pagination',
                            clickable: true
                        };
                        if (classesForSettings && classesForSettings.pagination) {
                            sliderSettings.breakpoints[breakpointSize].pagination.el = classesForSettings.pagination;
                        }  
                    }
                    if ('arrows' == sizeSetting && breakpointSizeSettings[sizeSetting] == true) {
                        sliderSettings.breakpoints[breakpointSize].navigation = {
                            enabled: breakpointSizeSettings[sizeSetting],
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev'
                        };
                        if (classesForSettings && classesForSettings.next && classesForSettings.prev) {
                            sliderSettings.breakpoints[breakpointSize].navigation.nextEl = classesForSettings.next;
                            sliderSettings.breakpoints[breakpointSize].navigation.prevEl = classesForSettings.prev;
                        }
                    }
                    if ('slidesToShow' == sizeSetting) {
                        sliderSettings.breakpoints[breakpointSize].slidesPerView = breakpointSizeSettings.slidesToShow;
                    }
                    if ('slidesToScroll' == sizeSetting) {
                        sliderSettings.breakpoints[breakpointSize].slidesPerGroup = breakpointSizeSettings.slidesToScroll;
                    }
                    if ('autoplay' in breakpointSizeSettings) {
                        sliderSettings.autoplay = {
                            delay: breakpointSizeSettings.autoplay,
                            disableOnInteraction: true
                        };
                    } else {
                        sliderSettings.breakpoints[breakpointSize].autoplay = false;
                    }
                }
            }
        }
    }
    
    return new Swiper (elementSelector, sliderSettings);
}

function formatSlickHTML($element, settings, isEinstein) {
    var originalSlideElements = $element.children().toArray();
    var uniqueSlider;

    if ($element.attr('id') && $element.attr('id').indexOf('slider-index') > -1) {
        uniqueSlider = $element.attr('id');
    } else {
        uniqueSlider = 'slider-index-' + getUniqueNumber().toString();
    }

    $element.attr('id', uniqueSlider);

    // Einstein CQuotient scripts are mixed in with slides at time of slider initialization. Rework the HTML structure.
    if (originalSlideElements.length > 0 && isEinstein) {
        var modifiedSlideElements = [];
        var cqScripts = [];

        $.each(originalSlideElements, function(index, element) {
            if (element.tagName.toUpperCase() === 'SCRIPT') {
                cqScripts.push(element);
            } else {
                if (element.tagName.toUpperCase() === 'LI') {
                    modifiedSlideElements.push(element);
                }  
            }
        });

        if (cqScripts.length > 0) {
            $element.closest('div.slider-clip').append(cqScripts);
        }

        $element.html('');
        $element.append(modifiedSlideElements);
    }
    return;
}

function formatSwiperHTML($element, settings, isEinstein) {
    var originalSlideElements = $element.children().toArray();
    var uniqueSlider, sortedSlidesPerViewArray, addSlides, finalSlides;
    var isLoop = true;
    var slidesPerViewArray = [];
    var cqScripts = [];
    var modifiedSlideElements = [];
    var duplicatedSlideElements = [];
    var hasSwiperHTML = $element.hasClass('swiper-full-wrapper') && $element.find('.swiper').length > 0;
    var swiperClassesForSettings = {};

    if ($element.attr('id') && $element.attr('id').indexOf('slider-index') > -1) {
        uniqueSlider = $element.attr('id');
    } else {
        uniqueSlider = 'slider-index-' + getUniqueNumber().toString();
    }

    var $swiperParent = $('<div />', { 'class': 'swiper', 'id': uniqueSlider }),
        $swiperPagination = $('<div />', { 'class': 'swiper-pagination swiper-pagination-' + uniqueSlider }),
        $swiperNavigation = $('<div />', { 'class': 'swiper-navigation-buttons-container' }),
        $swiperPrevArrow = $('<div />', { 'class': 'swiper-button-prev swiper-button-prev-' + uniqueSlider }),
        $swiperNextArrow = $('<div />', { 'class': 'swiper-button-next swiper-button-next-' + uniqueSlider }),
        $swiperWrapper = $('<div />', { 'class': 'swiper-wrapper' });

    if (settings) {
        if ('breakpoints' in settings) {
            for (var breakpointSize in settings.breakpoints) {
                var breakpointSizeSettings = settings.breakpoints[breakpointSize];

                /* --- Swiper Arrows Navigation --- */
                // Swiper does not display arrows by default the way Slick does. We must actively include them to match the defaults of Slick.
                var navDisplayClass = breakpointSize == '0' ? 'show-mobile-nav-buttons' : 'show-desktop-nav-buttons';
                $swiperNavigation.addClass(navDisplayClass);

                // If arrows were deliberately set to false in settings, that means hide them for all breakpoint sizes.
                if ('arrows' in settings) {
                    if (settings.arrows == false) {
                        $swiperNavigation.removeClass('show-mobile-nav-buttons show-desktop-nav-buttons');
                    }
                // Else if arrows were deliberately set to false for specific breakpoint, then hide for that breakpoint.
                } else if ('arrows' in breakpointSizeSettings) {
                    if (breakpointSizeSettings.arrows == false) {
                        $swiperNavigation.removeClass(navDisplayClass);
                    }
                }

                /* --- Swiper Dots Pagination --- */
                // Swiper does not display pagination dots by default the way Slick does. We must actively include them to match the defaults of Slick.
                var paginationDisplayClass = breakpointSize == '0' ? 'show-mobile-pagination' : 'show-desktop-pagniation';
                $swiperPagination.addClass(paginationDisplayClass);

                // If dots were deliberately set to false in settings, that means hide them for all breakpoint sizes.
                if ('dots' in settings) {
                    if (settings.dots == false) {
                        $swiperPagination.removeClass('show-mobile-pagination show-desktop-pagniation');
                    }
                // Else if dots were deliberately set to false for specific breakpoint, then hide for that breakpoint.
                } else if ('dots' in breakpointSizeSettings) {
                    if (breakpointSizeSettings.dots == false) {
                        $swiperPagination.removeClass(paginationDisplayClass);
                    }
                }

                if ('slidesToShow' in breakpointSizeSettings) {
                    slidesPerViewArray.push(parseInt(breakpointSizeSettings.slidesToShow));
                }
            }
        } else {
            // Swiper does not display arrows by default the way Slick does. We must actively include them to match the defaults of Slick.
            $swiperNavigation.addClass('show-mobile-nav-buttons show-desktop-nav-buttons');

            // If arrows were deliberately set to false in settings, that means hide them for all breakpoint sizes.
            if ('arrows' in settings) {
                if (settings.arrows == false) {
                    $swiperNavigation.removeClass('show-mobile-nav-buttons show-desktop-nav-buttons');
                }
            }

            // Swiper does not display pagination dots by default the way Slick does. We must actively include them to match the defaults of Slick.
            $swiperPagination.addClass('show-desktop-pagniation show-mobile-pagination');

            // If dots were deliberately set to false in settings, that means hide them for all breakpoint sizes.
            if ('dots' in settings) {
                if (settings.dots == false) {
                    $swiperPagination.removeClass('show-desktop-pagniation show-mobile-pagination');
                }
            }
        }
        if ('loop' in settings) {
            isLoop = settings.loop;
        }
    }   
    
    // Content overrides for slides to show
    if ($element.attr('data-desktop-slides') || $element.attr('data-mobile-slides')) {
        if ($element.attr('data-desktop-slides')) {
            slidesPerViewArray.push(parseInt($element.attr('data-desktop-slides')));
        }
        if ($element.attr('data-mobile-slides')) {
            slidesPerViewArray.push(parseInt($element.attr('data-mobile-slides')));
        }
    }

    if (slidesPerViewArray) {
        sortedSlidesPerViewArray = slidesPerViewArray.sort(function (a, b) { return a - b; });
    }

    if (!hasSwiperHTML && originalSlideElements.length > 0) {
        $element.addClass('swiper-full-wrapper');

        // Einstein CQuotient scripts are mixed in with slides at time of slider initialization. Rework the HTML structure.
        if (isEinstein) {
            $.each(originalSlideElements, function(index, element) {
                if (element.tagName.toUpperCase() === 'SCRIPT') {
                    cqScripts.push(element);
                } else {
                    var formattedSlide;
                    if (element.tagName.toUpperCase() === 'DIV') {
                        formattedSlide = $(element).addClass('swiper-slide');
                    } else {
                        formattedSlide = $('<div />', { 'class': 'swiper-slide' }).html($(element).html());
                    }
                    modifiedSlideElements.push(formattedSlide);
                }
            });
        } else {
            // Proceed to modify regular slide elements (non-Einstein)
            modifiedSlideElements = originalSlideElements.map(function(element, index) {
                if (element.tagName.toUpperCase() === 'DIV') {
                    return $(element).addClass('swiper-slide')[0];
                } else {
                    return $('<div />', { 'class': 'swiper-slide' }).html($(element).html())[0];
                }
            });
        }

        // Add additional slides (according to lowest common multiple) to fix loop bug in Swiper
        if (modifiedSlideElements && sortedSlidesPerViewArray && isLoop) {
            var LCM = leastCommonMultiple(sortedSlidesPerViewArray);
            if (sortedSlidesPerViewArray.indexOf(LCM) > -1) {
                addSlides = (LCM * 2) - modifiedSlideElements.length;
            } else {
                addSlides = LCM - modifiedSlideElements.length;
            }
            if (addSlides < 0) {
                var HCM = sortedSlidesPerViewArray.reduce(function (a, b) { return a * b; });
                addSlides = HCM - modifiedSlideElements.length;
            }
            $.each(modifiedSlideElements, function(idx, item) {
                if (idx < addSlides) {
                    duplicatedSlideElements.push($(item).clone());
                }
            });
        }

        // Create final array of slide elements
        finalSlides = $.merge(modifiedSlideElements, duplicatedSlideElements);

        // Append new swiper HTML elements to swiper wrapper
        $swiperWrapper.append(finalSlides);
        $swiperNavigation.append($swiperPrevArrow).append($swiperNextArrow);
        $swiperParent.append($swiperWrapper).append($swiperPagination);

        // Set slide arrows either inside or outside slider container
        var arrowsPosition = settings && 'arrowsPosition' in settings ? settings.arrowsPosition : null;
        if (arrowsPosition && arrowsPosition == 'inside') {
            $swiperParent.append($swiperNavigation).addClass('swiper-inside-navigation');
        }

        // Replace swiper wrapper contents with new HTML
        $element.html($swiperParent);

        if (!arrowsPosition || arrowsPosition == 'outside') { // If arrows are outside, we have to wait until swiper wrapper has content in line above before we prepend
            $element.prepend($swiperNavigation);
        }
        if (isEinstein && cqScripts.length > 0) {
            $element.append(cqScripts);
        }

        // Grab the unique classes from all the new elements above and return for further use
        swiperClassesForSettings.parent = '#' + uniqueSlider;
        swiperClassesForSettings.pagination = '.swiper-pagination-' + uniqueSlider;
        swiperClassesForSettings.prev = '.swiper-button-prev-' + uniqueSlider;
        swiperClassesForSettings.next = '.swiper-button-next-' + uniqueSlider;
    }
    return swiperClassesForSettings;
}

function init (elementClass, settings, isEinstein) {
    var selector = elementClass;
    if (!elementClass || ($(elementClass).length == 0 && elementClass.indexOf(':has') < 0)) {
        return;
    }
    if (SitePreferences.CONTENT_SLOT_SLIDER == 'swiperJS') { 
        $(elementClass).each(function(n, elm) {
            var $element = $(elm);
            var hasSwiperHTML = $element.find('.swiper-initialized').length > 0;

            if (!hasSwiperHTML) {
                var classesForSettings = formatSwiperHTML($element, settings, isEinstein);
                if (!settings) {
                    settings = {};
                }
                if (classesForSettings) {
                    // Override selector class for ID if we have it
                    selector = classesForSettings.parent ? classesForSettings.parent : selector;
                    settings.pagination = {
                        el: classesForSettings.pagination,
                        clickable: true
                    };
                    settings.navigation = {
                        nextEl: classesForSettings.next,
                        prevEl: classesForSettings.prev
                    };    

                    // Content overrides for slides to show
                    if ($element.attr('data-desktop-slides') || $element.attr('data-mobile-slides')) {
                        if ($element.attr('data-desktop-slides')) {
                            if (settings.breakpoints && settings.breakpoints[768]) {
                                settings.breakpoints[768].slidesToShow = parseInt($element.attr('data-desktop-slides'));
                            } else {
                                if (!settings.breakpoints) {
                                    settings.breakpoints = { 768: { slidesToShow: parseInt($element.attr('data-desktop-slides')) }};
                                }
                                if (!settings.breakpoints[768]) {
                                    settings.breakpoints[768] = { slidesToShow: parseInt($element.attr('data-desktop-slides')) };
                                }
                            }
                        }
                        if ($element.attr('data-mobile-slides')) {
                            if (settings.breakpoints && settings.breakpoints[0]) {
                                settings.breakpoints[0].slidesToShow = parseInt($element.attr('data-mobile-slides'));
                            } else {
                                if (!settings.breakpoints) {
                                    settings.breakpoints = { 0: { slidesToShow: parseInt($element.attr('data-mobile-slides')) }};
                                }
                                if (!settings.breakpoints[0]) {
                                    settings.breakpoints[0] = { slidesToShow: parseInt($element.attr('data-mobile-slides')) };
                                }
                            }
                        }   
                    }
                }
                return initSwiper(selector, settings, classesForSettings);
            }
        });
    } else {
        $(elementClass).each(function(n, elm) {
            var $element = $(elm);
            var elementIdSelector;
            formatSlickHTML($element, settings, isEinstein);
            elementIdSelector = '#' + $element.attr('id');
            initSlick(elementIdSelector, settings);
        });
    }
}

function leastCommonMultiple(values) {
    function gcd(a, b) {
        // Greatest common divisor of 2 integers
        return !b ? a : gcd(b, a % b);
    }

    function lcm(a, b) {
        // Least common multiple of 2 integers
        return (a * b) / gcd(a, b);   
    }

    var multiple = values[0];
    // Least common multiple of a list of integers
    values.forEach(function(n) {
        multiple = lcm(multiple, n);
    });

    // Return least common multiple for array of values
    return multiple;
}

function initializeCategorySliders(elementClass) {
	var $categorySliders = $(elementClass);
	if ($categorySliders.length > 0) {
		$categorySliders.each(function(index, element) {
			var $element = $(element);
            var categorySliderOptions = {
                breakpoints: {}
            };
            var uniqueSlider = 'category-slider-index-' + getUniqueNumber().toString();
            $element.addClass(uniqueSlider);

			// Desktop slot config options
			var categorySliderDesktopOptions = $element.attr('slider-desktop-options');
			if (categorySliderDesktopOptions) {
				categorySliderDesktopOptions = JSON.parse(categorySliderDesktopOptions);
                categorySliderOptions.breakpoints[categorySliderDesktopOptions.breakpointSize] = categorySliderDesktopOptions;
			}
			// Mobile slot config options
			var categorySliderMobileOptions = $element.attr('slider-mobile-options');
			if (categorySliderMobileOptions) {
				categorySliderMobileOptions = JSON.parse(categorySliderMobileOptions);
                categorySliderOptions.breakpoints[categorySliderMobileOptions.breakpointSize] = categorySliderMobileOptions;
			}

            init('.' + uniqueSlider, categorySliderOptions);
		});
	}
}

function initializeRecommendationSlider() {
	initializeSFCCProductRecommendationSliders();

	var attemptNumber = 0;
	var sliderInitializedClass = SitePreferences.CONTENT_SLOT_SLIDER == 'swiperJS' ? 'swiper-initialized' : 'slick-initialized';
    var sliderSelector = '.recomm-prod-anchor-slot .product-recommendations .slider-products-primary';
	function recommendationSliderIntervalHandler() {
    	var recommendationSliderInitialized;
        if (SitePreferences.CONTENT_SLOT_SLIDER == 'swiperJS') {
            recommendationSliderInitialized = $(sliderSelector).find('.' + sliderInitializedClass).length > 0;
        } else {
            recommendationSliderInitialized = $(sliderSelector).filter(function(index) {
                return $(this).hasClass(sliderInitializedClass);
            }).length > 0;
        }

		attemptNumber++;
		if(recommendationSliderInitialized || attemptNumber > 20) {
			$(document).trigger('EinsteinProductRecommendations.Done', $('#product-recommendations'));
            if (SitePreferences.CONTENT_SLOT_SLIDER == 'imgViewer2Slick') { 
			    $(document).trigger('SlickSliderAccessibilityMods');
            }
			clearInterval(timer);
			return;
		}
        $(sliderSelector).trigger('init-slider');
	}
	var timer = setInterval(recommendationSliderIntervalHandler, 500);
}

/**
 * @description Initializes the Einstein recommendations slot rendered inside the Add-to-Cart modal.
 * The slot's inline bootstrap script (which fires the Einstein recs request and the follow-up
 * CQRecomm-Start call) doesn't reliably execute on its own when injected via the modal's ajax
 * HTML swap, so it's re-run explicitly here. The actual recommendation markup then arrives
 * asynchronously afterward, so this polls for it before initializing the carousel.
 * @param {String} slotSelector - selector for the slot wrapper (e.g. '.recomm-prod-pdp-a2c-slot')
 */
function initializeAddToCartEinsteinSlot(slotSelector) {
	var $slot = $(slotSelector);
	if ($slot.length === 0) {
		return;
	}

	$slot.find('script').each(function() {
		var reRunScript = document.createElement('script');
		reRunScript.text = this.textContent;
		document.head.appendChild(reRunScript);
		document.head.removeChild(reRunScript);
	});

	initializeAddToCartRecommendationsSlider(slotSelector + ' .accordion.product-recommendations .slides', true);
}

/**
 * @description Polls for recommendation slides rendered inside the Add-to-Cart modal and initializes
 * the carousel with the modal's layout. The global 'init-slider' handlers in each site's app.js skip
 * anything under .atc-recommendations, so this is the only initializer for the modal's slider.
 * @param {String} slidesSelector - selector for the modal's .slides list
 * @param {Boolean} isEinstein - passed through to init() for Einstein-rendered markup
 */
function initializeAddToCartRecommendationsSlider(slidesSelector, isEinstein) {
	var attemptNumber = 0;
	var timer = setInterval(function() {
		if ($(slidesSelector).find('li').length > 0) {
			clearInterval(timer);
			init(slidesSelector, {breakpoints: {0: {slidesToShow: 1.5, arrows: true, dots: true}, 768: {slidesToShow: 2.5, arrows: true, dots: false}, 1024: {slidesToShow: 2.5, arrows: true, dots: false}}}, isEinstein);
			return;
		}

		attemptNumber++;
		if (attemptNumber > 50) {
			clearInterval(timer);
		}
	}, 200);
}

function initializeSFCCProductRecommendationSliders() {
	var attemptNumber = 0;
	var sliderInitializedClass = SitePreferences.CONTENT_SLOT_SLIDER == 'swiperJS' ? 'swiper-initialized' : 'slick-initialized';
    var sliderSelector = '.product-recommendations-sfcc .slider-products-primary .slides';
	var recommendationSlidersCount = $(sliderSelector).length;
	function recommendationSliderIntervalHandler() {
		var recommendationSlidersInitialized;
        if (SitePreferences.CONTENT_SLOT_SLIDER == 'swiperJS') {
            recommendationSlidersInitialized = $(sliderSelector).find('.' + sliderInitializedClass).length == recommendationSlidersCount;
        } else {
            recommendationSlidersInitialized = $(sliderSelector).filter(function(index) {
                return $(this).hasClass(sliderInitializedClass);
            }).length == recommendationSlidersCount;
        }

		attemptNumber++;
		if(recommendationSlidersInitialized || attemptNumber > 20) {
			$(document).trigger('SFCCProductRecommendations.Done');
            if (SitePreferences.CONTENT_SLOT_SLIDER == 'imgViewer2Slick') { 
			    $(document).trigger('SlickSliderAccessibilityMods');
            }
			clearInterval(timer);
			return;
		}
        $(sliderSelector).trigger('init-slider');
	}
	var timer = setInterval(recommendationSliderIntervalHandler, 500);
}